import { ASSET_TYPES, dataSources } from 'helpers/constants';
import { getAssetDataSourceType, getAssetTypeId } from 'helpers/assetAndPowertrainFilterHelper';
import { reportTypes } from '../constants';

export const getFilterForReportType = (reportType) => {
    if (reportType?.reportTypeId === reportTypes.InstantAssetMotor || reportType?.reportTypeId === reportTypes.MotorFleetDetailedInstantReport) {
        return {
            dataSourceType: dataSources.SMARTSENSOR,
            typeID: ASSET_TYPES.MOTOR
        };
    }
    else if (reportType?.reportTypeId === reportTypes.Drive || reportType?.reportTypeId === reportTypes.DriveFleetDetailedInstantReport) {
        return { dataSourceType: dataSources.CMD4 };
    }
    return null;
};

export const getReportNotificationLabel = (reportType) => {
    return reportType.reportTypeId === reportTypes.InstantAssetMotor ?
        'ABB.Powertrain.Frontend.reportInstantMotorReportNotification' :
        '';
};

const isAssetForReportingFilterMatching = (asset, filters) => {
    const assetDataSourceType = getAssetDataSourceType(asset);
    const dataSourceFilterIsMatching = filters?.dataSourceType
        ? filters.dataSourceType === assetDataSourceType : true;
    const assetTypeFilterIsMatching = filters?.typeID
        ? filters.typeID === getAssetTypeId(asset?.assetType) : true;
    return dataSourceFilterIsMatching
        && assetTypeFilterIsMatching;
};

export const filterAssetsForReportGeneration = (assets, filters) => {
    return assets?.filter(asset => isAssetForReportingFilterMatching(asset, filters));
};

export const isReportMetricOnly = ({ reportTypeId }) => reportTypeId === reportTypes.Drive || reportTypeId === reportTypes.DriveFleetReport;

export const isReportTypeFleet = reportTypeId => reportTypeId === reportTypes.DriveFleetReport || reportTypeId === reportTypes.MotorFleetReport;

export const isReportTypeFleetDetailedInstant = reportTypeId => reportTypeId === reportTypes.DriveFleetDetailedInstantReport || reportTypeId === reportTypes.MotorFleetDetailedInstantReport;
